import { h$1 as i, me as m, Y as v, m as h, o as g } from "../chunks/register-Ba9sFUKZ.js";
import * as f from "react";
import { f as r } from "../chunks/query-assigned-elements-CMnZBBH0.js";
import { t as p } from "../chunks/uid-DGLBmjXH.js";
const b = {
  beaconTagName: "beacon-menu"
}, y = i`[beacon-tag-name=beacon-menu] :is(li),[beacon-tag-name=beacon-menu] :is(li)>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);inline-size:auto;text-decoration:none;white-space:inherit}[beacon-tag-name=beacon-menu] :is(li):hover a{color:var(--beacon-system-color-text-link);text-decoration:underline}[beacon-tag-name=beacon-menu] :is(li){align-items:center;display:flex;flex-direction:row;gap:var(--beacon-reference-space-2)}[beacon-tag-name=beacon-menu] :is(li) :is(svg){block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5);stroke:var(--beacon-system-color-border-link)}[beacon-tag-name=beacon-menu] :is(li,h1,h2,h3,h4,h5,h6){padding:var(--beacon-system-space-cell-contained)}[beacon-tag-name=beacon-menu] [slot=title],[beacon-tag-name=beacon-menu] [slot=title]>*{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}`, B = i`:host ::slotted(ul),:host ::slotted(ol){display:flex;flex-direction:column;gap:var(--beacon-reference-space-3);inline-size:auto;list-style:none;margin:0;padding:0}`;
var E = Object.defineProperty, d = (t, e, o, c) => {
  for (var n = void 0, a = t.length - 1, l; a >= 0; a--)
    (l = t[a]) && (n = l(e, o, n) || n);
  return n && E(e, o, n), n;
};
const u = class extends m {
  constructor() {
    super(...arguments), this.beaconTagName = b.beaconTagName;
  }
  static get styles() {
    return [super.styles, B];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, y];
  }
  handleSlotChange() {
    if (this.slottedMenu) {
      const e = this.slottedMenu[0];
      e == null || e.setAttribute("role", "menu"), e == null || e.querySelectorAll("li").forEach((o) => {
        o.setAttribute("role", "menuitem");
      });
    }
  }
  /**
   * Assigns an ID to the slotted title, and applies
   * the ID to the menu as `aria-labelledby`.
   */
  handleTitleSlotChange() {
    var e, o;
    if ((e = this.slottedTitle) != null && e.length) {
      const c = this.slottedTitle[0], n = (o = this.slottedMenu) == null ? void 0 : o[0];
      if (n) {
        const a = p();
        n.setAttribute("aria-labelledby", c.id || a), c.id = c.id || a;
      }
    }
  }
  render() {
    return v`<slot
        name="title"
        @slotchange=${this.handleTitleSlotChange}></slot>
      <slot @slotchange=${this.handleSlotChange}></slot>`;
  }
};
u.tagName = b.beaconTagName;
let s = u;
d([
  r({ slot: "", selector: "ul, ol" })
], s.prototype, "slottedMenu");
d([
  r({ slot: "title" })
], s.prototype, "slottedTitle");
const N = (t) => (h(t, s), g({
  tagName: t ? t + "-" + s.tagName : s.tagName,
  elementClass: s,
  react: f,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  N as default,
  N as reactBeaconMenu
};
